import React from 'react';

export const LocalModuleContext = React.createContext({});
LocalModuleContext.displayName = 'LocalModuleContext';
